import { PageHeader } from '../../components/PageHeader';
import { WorkspaceTabs } from '../../components/WorkspaceTabs';
import { UsersListContent } from './users/UsersPage';
import { RolesListContent } from './roles/RolesPage';
import { ApprovalMatrixContent } from './approval-matrix/ApprovalMatrixPage';
import { ApprovalMatrixHealthContent } from './ApprovalMatrixHealthPage';

/**
 * The real merge requested: People, Roles, and Approval Rules used to
 * be three separate pages with separate navigation entries - genuinely
 * one system (who someone is, what a role lets them do, and who
 * approves what) presented as three disconnected things. Health Check
 * is included too - it's the one screen that actually confirms a
 * setup will work, so it belongs where people are setting things up,
 * not hidden on a separate page nobody thinks to visit. One page, one
 * PageHeader, four tabs - each tab reuses the exact same content
 * component the old standalone pages still use for direct/bookmarked
 * links, so nothing is duplicated or drifts apart.
 */
export function AccessManagementPage() {
  return (
    <div className="page">
      <PageHeader title="People & Access" description="Manage who has access to VConnect, what they're allowed to do, and who approves what." />
      <WorkspaceTabs
        tabs={[
          { key: 'people', label: 'People', content: <UsersListContent /> },
          { key: 'roles', label: 'Roles', content: <RolesListContent /> },
          { key: 'approval-rules', label: 'Approval Rules', content: <ApprovalMatrixContent /> },
          { key: 'health', label: 'Check Setup', content: <ApprovalMatrixHealthContent /> },
        ]}
      />
    </div>
  );
}
